import Component from 'flarum/common/Component';
import BsiIcon from './BsiIcon';
import { t, text } from '../helpers';
const stages = [['request', 'file-code'], ['quote', 'receipt'], ['payment', 'credit-card'], ['work', 'cpu'], ['result', 'download-simple']];
// Payment is complete only when the server reports a confirmed status. PAID
// stays on the payment step until an administrator actually starts the work.
const states = {
  NEW: {
    current: 1,
    completed: 0
  },
  QUOTED: {
    current: 2,
    completed: 1
  },
  PAYMENT_PENDING: {
    current: 2,
    completed: 1
  },
  PAID: {
    current: 2,
    completed: 2
  },
  IN_PROGRESS: {
    current: 3,
    completed: 2
  },
  COMPLETED: {
    current: 4,
    completed: 4
  }
};
export default class OrderProgress extends Component {
  view() {
    const {
      status
    } = this.attrs;
    const state = states[status];
    return m("section", {
      className: 'BsiOrderProgress' + (!state ? ' BsiOrderProgress--closed' : ''),
      "aria-label": text('progress.title')
    }, m("div", {
      className: "BsiOrderProgress-heading"
    }, m(BsiIcon, {
      name: state ? 'list-checks' : 'arrow-u-up-left'
    }), m("h2", null, t('progress.title')), m("span", null, t('status.' + status))), state ? m("ol", null, stages.map((_ref, index) => {
      let [key, icon] = _ref;
      const done = index <= state.completed;
      const current = index === state.current;
      return m("li", {
        key: key,
        className: (done ? 'is-done ' : '') + (current ? 'is-current' : ''),
        "aria-current": current ? 'step' : undefined
      }, m("span", {
        className: "BsiOrderProgress-marker"
      }, m(BsiIcon, {
        name: done ? 'check' : icon
      })), m("span", {
        className: "BsiOrderProgress-label"
      }, t('progress.' + key)), done && m("span", {
        className: "BsiVisuallyHidden"
      }, t('progress.done')));
    })) : m("p", null, t('order.hint_' + status)));
  }
}
flarum.reg.add('bsi-orders', 'forum/components/OrderProgress', OrderProgress);